module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "channel-cards"
  }, [(_vm.items.length) ? _c('div', {
    staticClass: "cards-container"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "card",
      class: {
        selected: item.selected
      },
      on: {
        "click": function($event) {
          _vm.toggleSelected(index)
        }
      }
    }, [_c('span', {
      staticClass: "mark"
    }), _vm._v(" "), _c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": item.picture,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.items.length) ? _c('div', {
    staticClass: "displayfield"
  }, [_vm._v("Nincs kiválasztható oldal")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6765edb7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/channel-cards.vue
// module id = 478
// module chunks = 2